const STORAGE_KEY = 'participantEmbed'
const ENABLED_VALUES = ['1', 'true']
const DISABLED_VALUES = ['0', 'false']

function readLatched() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true'
  } catch (error) {
    return false
  }
}

function clearLatch() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    // storage blocked: nothing latched that we could clear
  }
}

function latch() {
  try {
    sessionStorage.setItem(STORAGE_KEY, 'true')
  } catch (error) {
    // storage blocked: the in-memory flag still applies for this page load
  }
}

export function resolveParticipantEmbed(search) {
  const value = new URLSearchParams(search).get('embed')
  if (ENABLED_VALUES.includes(value)) {
    latch()
    return true
  }
  if (DISABLED_VALUES.includes(value)) {
    clearLatch()
    return false
  }
  return readLatched()
}

const getters = {
  isParticipantEmbed: (state) => state.isParticipantEmbed,
}

const participantEmbed = {
  namespaced: true,
  state: () => ({ isParticipantEmbed: resolveParticipantEmbed(window.location.search) }),
  getters,
}

export default participantEmbed
